import * as React from 'react';
import styled from '@emotion/styled';

import { controlBase, errorRing } from './_mixins';
import { Icon } from './Icon';

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  error?: boolean;
}

const Wrap = styled.span`
  position: relative;
  display: flex;
  width: 100%;
`;

const Field = styled.select<{ $error?: boolean }>`
  ${({ theme }) => controlBase(theme)}
  padding-right: 32px;
  ${({ theme, $error }) => $error && errorRing(theme)}
  cursor:pointer;
`;

const Chevron = styled(Icon)`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: ${({ theme }) => theme.color.fg.subtle};
  pointer-events: none;
`;

/** Lumen native select with chevron affordance. Pass <option>s as children. */
export function Select({ error, children, ...rest }: SelectProps) {
  return (
    <Wrap>
      <Field $error={error} {...rest}>{children}</Field>
      <Chevron name="chevDown" size={14} />
    </Wrap>
  );
}
